export default [
  {
    path: '/unbind-index',
    component: () => import('@/views/unbind/Index.vue'),
    name: 'unbind-index',
    meta: {
      title: '申请解绑',
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/unbind-agreement',
    component: () => import('@/views/unbind/Agreement.vue'),
    name: 'unbind-agreement',
    meta: {
      title: '车辆绑定申请须知',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/unbind-success',
    component: () => import('@/views/unbind/Success.vue'),
    name: 'unbind-success',
    meta: {
      title: '申请解绑',
      backgroundClass: 'bg-white',
    },
  },
];
